import { render, staticRenderFns } from "./questionsDetail.vue?vue&type=template&id=0af24a89&scoped=true&"
import script from "./questionsDetail.vue?vue&type=script&lang=js&"
export * from "./questionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./questionsDetail.vue?vue&type=style&index=0&id=0af24a89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af24a89",
  null
  
)

export default component.exports